import { createSelector } from 'reselect'

const getTour = state => state.get('tour')

export const getTourStepIndex = createSelector(getTour, tour => tour.get('stepIndex'))
